import angular from 'angular';

// @ngInject
function PrintingQueueApiService(DS, DSHttpAdapter) {
  return {
    getAll,
  };

  function getAll(
    sorting,
    pageNumber,
    pageSize,
    orderNumber,
    stadiumOrderNumber,
    fromDate,
    toDate,
  ) {
    const entries = Object.entries(sorting);
    const sort = entries.map(([key, direction]) => ({ key, direction }));

    const params = {
      from: (pageNumber - 1) * pageSize,
      pageSize,
      sorting: sort,
      stadiumOrderNumber: stadiumOrderNumber || '',
      orderNumber: orderNumber || '',
      fromDate: fromDate || '',
      toDate: toDate || '',
    };

    const url = `${DS.defaults.baseUrl}printing-queue-items/_search`;
    return DSHttpAdapter.POST(url, params)
      .then((response) => response.data);
  }
}

export default angular
  .module('resources.printingQueue', [])
  .factory('PrintingQueueApiService', PrintingQueueApiService)
  .name;
